__webpack_require__.p = "https://assets-ab.periodica.press/d83500c-24464868156/";